import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-about">
            <h3>Home Aide CNA Bridge Training Center</h3>
            <p>
              We provide cutting-edge training that equips students to handle the challenges of professional healthcare environments.
            </p>
            <div className="social-links">
            <a href="#"><FontAwesomeIcon icon={faFacebookF} /></a>
            <a href="#"><FontAwesomeIcon icon={faTwitter} /></a>
            <a href="#"><FontAwesomeIcon icon={faInstagram} /></a>
            <a href="#"><FontAwesomeIcon icon={faLinkedinIn} /></a>
            </div>
          </div>
          
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/courses">Courses</a></li>
              <li><a href="/online-courses">Online Courses</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
          
         
           
          
          <div className="footer-contact">
            <h3>Contact Us</h3>
            <address>
              1305 S. 312th St Suite 202<br />
              Federal Way, WA 98003<br /><br />
              Phone: +1 206 566 4676<br />
              Alternate: +1 206 592 2115<br />
              Email: homeaidecnacenter@gmail.com
            </address>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Home Aide CNA Bridge Training Center. All Rights Reserved.</p>
          <div className="legal-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;